'use client'

import type { PropsWithChildren } from 'react'

import { SpaceLayoutClient as SharedSpaceLayoutClient } from '@/components/space/space-layout-client'
import { SceneID } from '@/enums/agent'

interface SpaceLayoutClientProps extends PropsWithChildren {
  defaultOpen?: boolean
}

/**
 * Seedance Fast 页面布局客户端组件
 * 使用公共的 SpaceLayoutClient，配置 basePath 为 /seedance-fast，默认模型为 SEEDANCE2_FAST（可切换其他模型）
 */
export const SpaceLayoutClient = ({ children, defaultOpen = true }: SpaceLayoutClientProps) => {
  return (
    <SharedSpaceLayoutClient
      config={{ basePath: '/seedance-fast', defaultModelId: SceneID.SEEDANCE2_FAST }}
      defaultOpen={defaultOpen}
    >
      {children}
    </SharedSpaceLayoutClient>
  )
}
